<template>
    <div class="container" :style="{width:width+'px',height:height+'px'}">
    <!-- <div class="container"> -->
        <img class="icon1" src="https://imagessl.edujia.com/A-1ed71af7_20230814173509.png"/>
        <img class="icon2" src="https://imagessl.edujia.com/A-1ed71af7_20230814173727.png">
        <img class="icon3" src="https://imagessl.edujia.com/A-1ed71af7_20230814173954.png">
        <div class="top">
            <img class="logo" src="https://imagessl.edujia.com/A-1ed71af7_20230814174516.png"/>
            <div class="appName">微脉输入法</div>
        </div>
        <img class="top2" src="https://imagessl.edujia.com/A-1ed71af7_20230814174817.png" />
        <img class="screenshot" src="https://imagessl.edujia.com/A-1ed71af7_20230814175113.png"/>
        <div class="rightList">
            <div class="rightItem">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230814175544.png">
                <div>常用语、团队共享话术一键发送</div>
            </div>
            <div class="rightItem">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230814175544.png">
                <div>支持发图、视频二维码</div>
            </div>
            <div class="rightItem">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230814175544.png">
                <div>多团队可切换</div>
            </div>
            <div class="btnList">
                <div class="btnListItem" @click="macClick">
                    <img src="https://imagessl.edujia.com/A-1ed71af7_20230814180148.png"/>
                    <div>下载Mac版本</div>
                </div>
                <div class="btnListItem" @click="windowClick">
                    <img src="https://imagessl.edujia.com/A-1ed71af7_20230814180510.png"/>
                    <div>下载Windows版本</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Download",
        data(){
            return {
                width: document.documentElement.clientWidth || document.body.clientWidth,
                height: document.documentElement.clientHeight || document.body.clientHeight,
            }
        },
        mounted() {
            this.width= document.documentElement.clientWidth || document.body.clientWidth;;
            this.height= document.documentElement.clientHeight || document.body.clientHeight;
            window.addEventListener('resize',()=>{
                this.width=window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.height=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            })
        },
        methods:{
            downloadFile(url,fileName){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style = 'display: none'
                a.href = url
                a.download = fileName
                a.click()
                window.URL.revokeObjectURL(url)
            },
            macClick(){
                let ts=new Date().getTime();
                // this.downloadFile("https://imagessl.edujia.com/A-1ed71af7_20230925113720.zip","微脉输入法")
                this.downloadFile(" https://imagessl.edujia.com/ki-mac-1.0.8.zip?ts="+ts,"微脉输入法")
            },
            windowClick(){
                let ts=new Date().getTime();
                this.downloadFile("https://imagessl.lingtuo.cn/A-1ed71af7_20240428102146.zip?ts="+ts)
                // this.downloadFile("https://imagessl.edujia.com/A-1ed71af7_20240207171303.zip?ts="+ts)
                // this.downloadFile("https://imagessl.edujia.com/ki-1.0.7.zip?ts="+ts,"微脉输入法")
            }
        }
    }
</script>

<style scoped>
    .container{
        width: 100%;
        min-width: 972px;
        background-color: #FFF9F9;
        position: relative;
    }

    .icon1{
        width: 779px;
        position: absolute;
        right: 0;
        top: 0;
        height: 214px;
    }

    .icon2{
        width: 79px;
        height: 103px;
        position: absolute;
        left: 33px;
        top: 25px;

    }

    .icon3{
        width: 250px;
        position: absolute;
        left: 3.22%;
        top: 329px;
        height: 276px;
    }

    .top{
        display: flex;
        align-items: center;
        position: absolute;
        left: 13.7%;
        top: 176px;
    }

    .logo{
        width: 60px;
        height: 60px;
    }

    .appName{
        font-size: 36px;
        color: #FB5D5C;
        line-height: 50px;
        font-weight: 600;
    }

    .top2{
        width: 320px;
        height: 28px;
        position: absolute;
        left: 27.6%;
        top: 237px;
    }

    .screenshot{
        width: 401px;
        height: 304px;
        top: 301px;
        left: 13.7%;
        position: absolute;
    }

    .rightList{
        top: 309px;
        right: 13.7%;
        position: absolute;
    }

    .rightItem{
        font-size: 20px;
        color: #3C3C3C;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
    }

    .rightItem img{
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }

    .btnList{
    }

    .btnListItem{
        width: 214px;
        height: 56px;
        background-color: #FB5D5C;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        border-radius: 4px;
        margin-bottom: 48px;
    }

    .btnListItem img{
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }

    img{
        user-select: none;
        pointer-events: none;
    }
</style>